import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../assets/Generallogo.png';
import {
    FaTachometerAlt,
    FaPlusSquare,
    FaClipboardList,
    FaUserCircle,
    FaSignOutAlt,
    FaTimes,
    FaUsers,

} from 'react-icons/fa';

const AdminSidebar = ({ isOpen, toggleSidebar }) => {
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = React.useState(false);

    const handleLogout = () => {
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        localStorage.removeItem('adminUser');
        navigate('/admin_login');
    };

    const navItems = [
        { path: '/admin/dashboard', label: 'DASHBOARD', icon: <FaTachometerAlt /> },
        { path: '/admin/add-services', label: 'ADD SERVICES', icon: <FaPlusSquare /> },
        { path: '/admin/bookings', label: 'BOOKING DETAILS', icon: <FaClipboardList /> },
        { path: '/admin/users', label: 'USER LIST', icon: <FaUsers /> },
        { path: '/admin/profile', label: 'PROFILE', icon: <FaUserCircle /> },
    ];

    return (
        <aside className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
            <div className="sidebar-header d-flex flex-column align-items-start">
                <span className="sidebar-logo-text" style={{
                    fontWeight: '700',
                    color: '#fff',
                    letterSpacing: '2px',
                    fontSize: '1rem',
                    textTransform: 'uppercase',
                    fontFamily: 'Outfit, sans-serif',
                    lineHeight: '1.2'
                }}>
                    AL WASEEQ DESIGN
                </span>
                <span className="sidebar-tagline" style={{
                    fontSize: '0.45rem',
                    color: '#fff',
                    letterSpacing: '1px',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    opacity: '0.5',
                    marginTop: '4px'
                }}>
                    We Craft Your Dream World
                </span>
                <button className="sidebar-close d-lg-none" style={{ position: 'absolute', top: '40px', right: '35px' }} onClick={toggleSidebar}>
                    <FaTimes />
                </button>
            </div>

            <div className="sidebar-divider-center"></div>

            <nav className="sidebar-nav">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
                        onClick={() => window.innerWidth < 992 && toggleSidebar()}
                    >
                        <span className="sidebar-icon">{item.icon}</span>
                        <span className="sidebar-label">{item.label}</span>
                        <div className="active-indicator"></div>
                    </NavLink>
                ))}
            </nav>

            <div className="sidebar-footer">
                <button className="logout-btn" onClick={handleLogout}>
                    <FaSignOutAlt className="me-3" />
                    DISCONNECT
                </button>
            </div>

            {/* Admin Logout Confirmation Modal */}
            {showLogoutModal && (
                <div className="admin-modal-overlay">
                    <div className="admin-modal-content logout-confirm-box">
                        <div className="modal-header-custom border-0 pb-0">
                            <h4 className="m-0 text-white">SYSTEM DISCONNECT</h4>
                            <button className="btn-close-modal" onClick={() => setShowLogoutModal(false)}><FaTimes /></button>
                        </div>
                        <div className="modal-body-custom pt-4 text-center">
                            <div className="mb-4">
                                <div className="logout-glow-icon">
                                    <FaSignOutAlt />
                                </div>
                            </div>
                            <h5 className="text-white mb-3">Terminate Admin Session?</h5>
                            <p className="text-white-50 small mb-4">
                                You are about to disconnect from the administrative console.
                                Any unsaved architectural configurations may be lost.
                            </p>

                            <div className="d-flex gap-3 mt-5">
                                <button className="btn-admin-submit logout-final flex-grow-1" onClick={confirmLogout}>
                                    YES, DISCONNECT
                                </button>
                                <button className="btn-admin-outline px-4" onClick={() => setShowLogoutModal(false)}>
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style>{`
                .admin-sidebar {
                    width: 280px;
                    height: 100vh;
                    background: #0a0a0a;
                    border-right: 1px solid rgba(255, 255, 255, 0.05);
                    position: fixed;
                    left: 0;
                    top: 0;
                    display: flex;
                    flex-direction: column;
                    z-index: 1000;
                    transition: transform 0.3s ease;
                }

                .sidebar-header {
                    padding: 40px 35px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #000000;
                    position: relative;
                }

                .sidebar-divider-center {
                    height: 1px;
                    width: 80%;
                    margin: 0 auto;
                    background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.5), transparent);
                }

                .sidebar-logo {
                    height: 40px;
                    filter: brightness(0) invert(1);
                }

                .sidebar-nav {
                    flex: 1;
                    padding: 20px 10px;
                }

                .sidebar-link {
                    display: flex;
                    align-items: center;
                    padding: 12px 20px;
                    color: rgba(255, 255, 255, 0.5);
                    text-decoration: none;
                    letter-spacing: 2px;
                    font-size: 0.75rem;
                    position: relative;
                    transition: all 0.3s ease;
                    font-weight: 600;
                    border-radius: 8px;
                    margin-bottom: 5px;
                }

                .sidebar-icon {
                    font-size: 1.1rem;
                    margin-right: 15px;
                }

                .sidebar-link:hover {
                    color: white;
                    background: rgba(255, 255, 255, 0.05);
                }

                .sidebar-link.active {
                    color: #000000;
                    background: #C5A059;
                    box-shadow: 0 4px 15px rgba(197, 160, 89, 0.2);
                    border: none;
                    font-weight: 700;
                }

                .active-indicator {
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    width: 3px;
                    background: var(--secondary-color);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                }

                .sidebar-link.active .active-indicator {
                    opacity: 1;
                }

                .sidebar-footer {
                    padding: 30px;
                    border-top: 1px solid rgba(255, 255, 255, 0.03);
                }

                .logout-btn {
                    width: 100%;
                    background: none;
                    border: 1px solid rgba(220, 53, 69, 0.2);
                    color: #dc3545;
                    padding: 12px;
                    font-size: 0.7rem;
                    letter-spacing: 2px;
                    border-radius: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.3s ease;
                    font-weight: 600;
                }

                .logout-btn:hover {
                    background: #dc3545;
                    color: white;
                    border-color: #dc3545;
                }

                .sidebar-close {
                    background: none;
                    border: none;
                    color: white;
                    font-size: 1.2rem;
                }

                @media (max-width: 991px) {
                    .admin-sidebar {
                        transform: translateX(-100%);
                    }
                    .admin-sidebar.open {
                        transform: translateX(0);
                    }
                }

                /* Admin Shared Modal Styles (Consistent with AddServices/AdminBookings) */
                .admin-modal-overlay {
                    position: fixed;
                    inset: 0;
                    background: rgba(0,0,0,0.85);
                    backdrop-filter: blur(10px);
                    z-index: 10000;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                }

                .admin-modal-content {
                    width: 100%;
                    background: #0a0a0a;
                    border: 1px solid rgba(255,255,255,0.1);
                    border-radius: 4px;
                    overflow: hidden;
                    box-shadow: 0 50px 100px rgba(0,0,0,0.5);
                }

                .logout-confirm-box {
                    max-width: 400px;
                }

                .modal-header-custom {
                    padding: 25px 30px;
                    border-bottom: 1px solid rgba(255,255,255,0.05);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .modal-header-custom h4 {
                    font-size: 0.75rem;
                    letter-spacing: 3px;
                    font-weight: 400;
                }

                .btn-close-modal {
                    background: none;
                    border: none;
                    color: rgba(255,255,255,0.4);
                    font-size: 1.2rem;
                    transition: color 0.3s ease;
                }

                .btn-close-modal:hover { color: #fff; }

                .modal-body-custom {
                    padding: 40px;
                }

                .logout-glow-icon {
                    width: 70px;
                    height: 70px;
                    background: rgba(220, 53, 69, 0.1);
                    color: #dc3545;
                    border: 1px solid rgba(220, 53, 69, 0.3);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto;
                    font-size: 2rem;
                    box-shadow: 0 0 30px rgba(220, 53, 69, 0.1);
                }

                .btn-admin-submit {
                    background: var(--secondary-color);
                    border: none;
                    color: black;
                    padding: 12px 24px;
                    font-size: 0.75rem;
                    font-weight: 600;
                    letter-spacing: 2px;
                    border-radius: 2px;
                    transition: all 0.3s ease;
                }

                .btn-admin-submit:hover {
                    background: #d4ae6b;
                    transform: translateY(-3px);
                }

                .btn-admin-submit.logout-final {
                    background: #dc3545;
                    color: white;
                }

                .btn-admin-submit.logout-final:hover {
                    background: #bb2d3b;
                }

                .btn-admin-outline {
                    background: transparent;
                    border: 1px solid rgba(255,255,255,0.2);
                    color: white;
                    padding: 12px 24px;
                    font-size: 0.75rem;
                    letter-spacing: 2px;
                    transition: all 0.3s ease;
                }

                .btn-admin-outline:hover {
                    border-color: #fff;
                    background: rgba(255,255,255,0.05);
                }
            `}</style>
        </aside>
    );
};

export default AdminSidebar;